export default "__VITE_ASSET__e935d4f1__"